import React, { ReactNode, useEffect, useState } from 'react';
import DropdownItem from 'react-bootstrap/DropdownItem';
import styles from './BzDropdownButton.module.css';
import { ButtonProps } from 'react-bootstrap';
import clsx from 'clsx';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Dropdown from 'react-bootstrap/Dropdown';
import { getShortString } from 'utils/miscUtil';

export interface DropdownButtonItem {
  key: string;
  title: string;
  extraCls?: string;
}

interface DropdownButtonProps {
  id: string;
  dropdownItems: DropdownButtonItem[];
  selectedItem: DropdownButtonItem;
  onSelectedItem: (item: DropdownButtonItem) => void;
  className?: string;
  variant?: ButtonProps['variant'];
  width?: string;
  center?: boolean /** by default align the text in the button to the left */;
  alignRight?: boolean /** allows to align right the dropdown menu*/;
  disabled?: boolean;
  shortTitle?: boolean;
  maxHeight?: string;
}

const BzDropdownButton = (props: DropdownButtonProps) => {
  const dropdownItems: ReactNode = props.dropdownItems.map((di: DropdownButtonItem) => (
    <DropdownItem eventKey={di.key} key={di.key} id={`qa-dropdown-${props.id}-${di.key}`}>
      {di.title}
    </DropdownItem>
  ));

  const [selectedItem, setSelectedItem] = useState(props.selectedItem);

  useEffect(() => {
    setSelectedItem(props.selectedItem);
  }, [props.selectedItem]);

  const handleSelectionChange = (key: string) => {
    const selected: DropdownButtonItem = props.dropdownItems.find(
      (di: DropdownButtonItem) => di.key === key,
    ) as DropdownButtonItem;
    setSelectedItem(selected);
    props.onSelectedItem(selected as DropdownButtonItem);
  };

  const widthStyle = props.width ? { width: props.width } : { width: '100%' };

  return (
    <Dropdown
      as={ButtonGroup}
      style={widthStyle}
      onSelect={(key: string) => handleSelectionChange(key)}
      className={props.className}
    >
      <Dropdown.Toggle
        disabled={props.disabled}
        id={`qa-toggle-${props.id}`}
        variant={props.variant}
        title={selectedItem.title}
        className={clsx(
          props.center && styles.bzButtonCenter,
          !props.center && styles.bzButtonLeft,
          selectedItem.extraCls,
          'text-truncate',
          'pr-4',
        )}
      >
        {props.shortTitle != true ? selectedItem.title : getShortString(selectedItem.title, 10)}
      </Dropdown.Toggle>
      <Dropdown.Menu
        style={{
          maxHeight: props.maxHeight ? props.maxHeight : undefined,
          overflow: props.maxHeight ? 'auto' : undefined,
        }}
        alignRight={props.alignRight}
      >
        {dropdownItems}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default BzDropdownButton;
